import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=6a891142&lang=pug&"
import script from "./HomeMenu.vue?vue&type=script&lang=ts&"
export * from "./HomeMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMenu.vue?vue&type=style&index=0&id=6a891142&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports